import { Decoder, int, object, optional } from "@lu/typed-json";

import { AuthenticationResponse } from "../../../../server/types/request/http/internal/auth";

export const authResponseDecoder: Decoder<AuthenticationResponse> = object({
	groupId: optional(int()),
});
